import React, { useMemo } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Nav } from "react-bootstrap";
import { useProjectList } from "Constant/apiHooks";
import { paths } from "Constant/paths";

export default function AdminSettings() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const { projectList } = useProjectList();

  // Listing
  const allProjectList = useMemo(() => {
    return projectList?.length > 0
      ? projectList.map((res) => ({
          label: res.name,
          value: res.gid,
        }))
      : [];
  }, [projectList]);

  // paths
  const {
    admin: {
      settings: { stages, actions, field, attributes, roles, groups },
    },
  } = paths;

  return (
    <main className="main">
      <div className="page-title-box d-md-flex justify-content-between align-items-center">
        <h4 className="page-title">{t("common.button.adminSetting")}</h4>
      </div>
      <hr className="my-2 border-grey-400" />
      <div className="">
        <Nav className="parrent-tab nav-tabs nav-underline gap-4 mb-3">
          <Nav.Item className={pathname.includes(stages) ? "active" : ""}>
            <Link to={stages} className="nav-link">
              {t("common.button.stages")}
            </Link>
          </Nav.Item>
          <Nav.Item className={pathname.includes(actions) ? "active" : ""}>
            <Link to={actions} className="nav-link">
              {t("common.button.actions")}
            </Link>
          </Nav.Item>
          <Nav.Item className={pathname.includes(field) ? "active" : ""}>
            <Link to={field} className="nav-link">
              {t("common.button.fields")}
            </Link>
          </Nav.Item>
          <Nav.Item className={pathname.includes(attributes) ? "active" : ""}>
            <Link to={attributes} className="nav-link">
              {t("common.button.attributes")}
            </Link>
          </Nav.Item>
          <Nav.Item className={pathname.includes(roles) ? "active" : ""}>
            <Link to={roles} className="nav-link">
              {t("common.button.roles")}
            </Link>
          </Nav.Item>
          <Nav.Item className={pathname.includes(groups) ? "active" : ""}>
            <Link to={groups} className="nav-link">
              {t("common.button.groups")}
            </Link>
          </Nav.Item>
        </Nav>

        <Outlet context={{ projectList: allProjectList }} />
      </div>
    </main>
  );
}
